import { render, staticRenderFns } from "./selectModal.vue?vue&type=template&id=68bfa48e&"
import script from "./selectModal.vue?vue&type=script&lang=ts&"
export * from "./selectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports